export default "__VITE_ASSET__Byud$0NN__"